import { useEffect, useState } from 'react';
import { apiClient } from '@/lib/api-client';

/** Whether the caller's own profile has the address and tax code the PDF prints (R-c). */
export type OwnDetails = 'unknown' | 'missing' | 'present';

/**
 * Reads `GET /v1/profile`'s `ownerDetails` (null while unset), only when `enabled`: the page asks
 * for the caller's own profile, never for another person's. A failed read says nothing.
 */
export function useOwnDetails(enabled: boolean): OwnDetails {
  const [state, setState] = useState<OwnDetails>('unknown');
  useEffect(() => {
    if (!enabled) return;
    let live = true;
    apiClient
      .GET('/v1/profile')
      .then(({ data, response }) => {
        if (!live || !response.ok || data === undefined) return;
        setState(data.ownerDetails === null ? 'missing' : 'present');
      })
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [enabled]);
  return enabled ? state : 'unknown';
}
